import React from "react";

interface IconProps {
  icon: React.ReactNode;
  backgroundColor?: string;
  width?: number;
  height?: number;
  className?: string;
}

const Icon: React.FC<IconProps> = ({ icon, backgroundColor = "", width, height, className }) => {
  const bgClass = backgroundColor.startsWith("var(--") ? `bg-[${backgroundColor}]` : `bg-${backgroundColor}`;

  return (
    <div className={`${bgClass} w-${width} h-${height} flex items-center justify-center rounded-20 ${className}`}>
      {icon}
    </div>
  );
};

export default Icon;
